import {RestServiceAbstract} from '../../abstracts/rest-service.abstract';
import {Injectable} from '@angular/core';
import {map} from 'rxjs/operators';
import {ResponseSnakeModel} from '../../models/response-snake.model';

@Injectable({
  providedIn: 'root'
})
export class DialogRestService extends RestServiceAbstract {

  public getActiveDialogs(idf: String) {
    return this.get('/cms/dialogs/' + idf).pipe(map(data => {
      return new ResponseSnakeModel(data);
    }));
  }

  public getActiveDialogsOnPage(page: string, idf: String) {
    return this.get('/cms/dialogs/'+page +'/'+ idf).pipe(map(data => {
      return new ResponseSnakeModel(data);
    }));
  }

  public subscribeToDialogOffer(id, idf: String) {
   return this.post('/cms/dialogs', {subscribe: true, idf: idf, "dialog_id": id}).pipe(map(data => {
      return new ResponseSnakeModel(data);
    }));
  }

  public optOutToDialogOffer(id, idf: String) {
   return this.post('/cms/dialogs', {subscribe: false, idf: idf, "dialog_id": id}).pipe(map(data => {
      return new ResponseSnakeModel(data);
    }));
  }
}
